// utils/paymentUtils.js
// Deterministic payment record selector.
// Returns the most recent payment by created_at, or last element as fallback.

export function getLatestPayment(payments) {
  if (!payments || payments.length === 0) return null;
  if (payments.length === 1) return payments[0];
  // Sort copy by created_at DESC; fall back to array order if missing
  return [...payments].sort((a, b) => {
    if (a.created_at && b.created_at) return new Date(b.created_at) - new Date(a.created_at);
    return 0; // preserve original order if no timestamp
  })[0];
}
